<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to previous page" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="attendance" :pageId="viewedByOwner?'timesheet-submission':'timesheet-review'" color="white"></help-link>
                    <v-btn v-if="!loading" dark icon title="Export to Excel" @click="downloadToExcel" :loading="loading_download">
                        <v-icon>cloud_download</v-icon>
                    </v-btn>
                    
                    <v-chip v-if="frozenPeriod" label small class="warning" dark title="This period is already Frozen. You will not be able to change this timesheet.">Frozen</v-chip>
                    <v-chip v-if="closedPeriod" label small class="grey darken-2" dark title="This period is already Closed. You will not be able to change this timesheet.">Closed</v-chip>
                    
                    <v-menu  v-if="!loading && !isStatusMenuDisabled" v-model="menu_status" left offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn :color="commonfn.getStatusButtonColor(timereport.status)" dark v-on="on" :loading="loading_btn" class="mr-0">
                                <span class="ml-7">{{ statusLabel }}</span>
                                <v-icon>{{ menu_status ? 'arrow_drop_up' : 'arrow_drop_down' }}</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-tile v-for="(item, index) in menuItems" :key="index" @click="item.action">
                                <v-list-tile-title small>{{ item.label }}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>

                    <!-- fallback -->
                    <v-btn v-else-if="!loading" :color="commonfn.getStatusButtonColor(timereport.status)" dark class="mr-0">
                        {{ commonfn.getStatusDescription(timereport.status) }}
                    </v-btn>

                </v-toolbar>
            </v-card>
            
            <!-- alerts -->
            <v-alert v-if="error" :value="true" color="error" icon="error" outline class="mt-8">
                {{ errorMessage }}
            </v-alert>
            <v-alert v-if="otExceedsDailyHour" :value="true" color="error" icon="error" outline class="mt-8">
                Some overtime records show more than 8 hours in a single day. Please review the entries highlighted in red.
            </v-alert> 
            <v-alert v-if="!loading && incomplete_clock_hours>0" :value="true" color="warning" icon="warning" outline dismissible class="mt-8">
                Incomplete clock hours detected. If 'Validate Undertime' is enabled in the Workshift, undertime will be automatically deducted from the payroll. 
            </v-alert> 
            <v-alert v-if="!loading && unapproved_attcorrections>0" :value="true" color="warning" icon="warning" outline dismissible class="mt-8">
                There are un approved Attendance Corrections. <span style="cursor:pointer;" @click="viewAttendanceCorrections"><b><u>Click here</u></b></span> to view details. 
            </v-alert> 
            <v-alert v-if="!loading && unapproved_timeoff>0" :value="true" color="warning" icon="warning" outline dismissible class="mt-8">
                There are un approved Time Off. <span style="cursor:pointer;" @click="viewTimeOff"><b><u>Click here</u></b></span> to view details. 
            </v-alert>
            <v-alert v-if="!loading && unapproved_overtime>0" :value="true" color="warning" icon="warning" outline dismissible class="mt-8">
                There are un approved Overtime. <span style="cursor:pointer;" @click="viewOvertime"><b><u>Click here</u></b></span> to view details. 
            </v-alert> 
           
            <!-- details -->
            <v-layout row wrap class="mg-5 mb-5">   
                <v-flex xs12>
                    <v-card class="elevation-1 transparent">
                        <v-toolbar flat height="45px">
                            <b v-if="viewedByOwner">My Timesheet</b>
                            <v-chip v-if="!viewedByOwner" @click="viewUserProfile(timereport, $store.state.userId)" class="user-chip-container">
                                <v-avatar>
                                    <v-img :src="awsS3Helper.getAvatarUrl(timereport.userId)"></v-img>
                                </v-avatar>
                                <b>{{timereport.firstName}} {{timereport.lastName}}</b>
                            </v-chip>
                            <v-btn v-if="!viewedByOwner" @click="showOtherEmployees" icon title="View all team members">
                                <v-icon>list</v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <b v-if="isMobile">{{ header_text_mobile }}</b>
                            <b v-else>{{ header_text }}</b>
                        </v-toolbar>
                        
                        <v-data-table
                            :headers="isMobile ? [] : headers_timesheet"
                            :items="timesheetData"
                            :loading="loading"
                            :rows-per-page-items="rowsPerPageItems"
                            :pagination.sync="paginationSync"
                            :hide-headers="isMobile"
                        >
                            <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                            <template v-slot:items="props">

                                <!-- mobile view -->
                                <tr v-if="isMobile">
                                    <td :colspan="headers_timesheet.length" class="pa-1">
                                        <v-card class="elevation-1" @click="viewDetails(props.item)">
                                            <v-toolbar flat height="42">
                                                <v-chip small class="user-chip-container">
                                                    <b>{{ props.item.transDate | moment('MMM DD ddd') }}</b>
                                                </v-chip>
                                                <v-spacer></v-spacer>
                                                <v-chip v-if="props.item.workshift" small :style="`background-color:${props.item.workshift.color};`">
                                                    {{ props.item.workshift.clockStart | moment('h:mma')}} - {{ props.item.workshift.clockEnd | moment('h:mma')}}
                                                </v-chip>
                                            </v-toolbar>
                                            <v-layout row wrap align-center class="section-layout">
                                                <v-flex xs12 class="text-xs-left mt-5">
                                                    <v-layout row>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Clock In/Out</div>
                                                            <div>{{ props.item.clockIn | moment('hh:mma') }} - {{ props.item.clockOut | moment('hh:mma') }}</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Minutes Late</div>
                                                            <div v-if="props.item.minsLate">{{ props.item.minsLate }} mins</div>
                                                            <div v-else>-</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Total Hours</div>
                                                            <div v-if="props.item.totalHours">{{ props.item.totalHours }}</div>
                                                            <div v-else>-</div>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Chargeable Hours</div>
                                                            <div v-if="props.item.chargeablePayrollHours">{{ props.item.chargeablePayrollHours }}</div>
                                                            <div v-else>-</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Night Differential</div>
                                                            <div v-if="props.item.chargeableNDHours != '00:00'">{{ props.item.chargeableNDHours }}</div>
                                                            <div v-else>-</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Workshift Night Diff</div>
                                                            <div v-if="props.item.chargeableWSNDHours != '00:00'">{{ props.item.chargeableWSNDHours }}</div>
                                                            <div v-else>-</div>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Attendance Corrections</div>
                                                            <div v-if="props.item.attendanceCorrectionsStatus">
                                                                <b v-if="props.item.attendanceCorrectionsStatus==commonfn.getStatusCode('Created') || props.item.attendanceCorrectionsStatus==commonfn.getStatusCode('For Review')" class='warning--text'>{{ props.item.attendanceCorrectionsChargeableHours }}</b>
                                                                <b v-if="props.item.attendanceCorrectionsStatus==commonfn.getStatusCode('Approved')" class='green--text'>{{ props.item.attendanceCorrectionsChargeableHours }}</b>
                                                                <b v-if="props.item.attendanceCorrectionsStatus==commonfn.getStatusCode('Rejected')" class='red--text'>{{ props.item.attendanceCorrectionsChargeableHours }}</b>
                                                            </div>
                                                            <div v-else>-</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Time Off</div>
                                                            <div v-if="props.item.timeOffChargeableHours">
                                                                <b v-if="props.item.timeOffWithUnApproved==1" class='warning--text' >{{ props.item.timeOffChargeableHours }}</b>
                                                                <b v-else class='green--text'>{{ props.item.timeOffChargeableHours }}</b>
                                                            </div>
                                                            <div v-else>-</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Overtime</div>
                                                            <div v-if="props.item.otChargeableHours">
                                                                <span v-if="exceedsDailyHours(props.item.otChargeableHours)">
                                                                    <b class='red--text'>{{ props.item.otChargeableHours }}</b> 
                                                                </span>
                                                                <span v-else>
                                                                    <b v-if="props.item.otWithUnApproved==1" class='warning--text' >{{ props.item.otChargeableHours }}</b>
                                                                    <b v-else class='green--text'>{{ props.item.otChargeableHours }}</b>    
                                                                </span>
                                                            </div>
                                                            <div v-else>-</div>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>
                                        </v-card>
                                    </td>
                                </tr>

                                <!-- desktop view -->
                                <tr v-else :class="viewedByOwner?'clickable':''" @click="viewDetails(props.item)" :title="viewedByOwner?'Click to view/edit details in My Attendance':''">
                                    <td>
                                        <v-chip small class="user-chip-container">
                                            {{ props.item.transDate | moment('MMM DD dd') }}
                                        </v-chip>
                                    </td>
                                    <td>
                                        <v-chip v-if="props.item.workshift" small :style="`background-color:${props.item.workshift.color}; margin-left:-10px;`" :title="props.item.workshift.name">
                                            {{ props.item.workshift.clockStart | moment('h:mma')}} - {{ props.item.workshift.clockEnd | moment('h:mma')}}
                                        </v-chip>
                                    </td>
                                    <td>
                                        <v-chip v-if="props.item.clockIn" small class="clock-chip">
                                            {{ props.item.clockIn | moment('hh:mma') }} - {{ props.item.clockOut | moment('hh:mma') }}
                                        </v-chip>
                                    </td>
                                    <td>
                                        <span v-if="props.item.minsLate">{{ props.item.minsLate }} mins</span>
                                    </td>
                                    <td>{{ props.item.totalHours }}</td>
                                    <td>{{ props.item.chargeablePayrollHours }}</td>  
                                    <td>
                                        <span v-if="props.item.chargeableNDHours != '00:00'">{{ props.item.chargeableNDHours }}</span>
                                    </td>
                                    <td>
                                        <span v-if="props.item.chargeableWSNDHours != '00:00'">{{ props.item.chargeableWSNDHours }}</span>
                                    </td>                                          
                                    <td>
                                        <b v-if="props.item.attendanceCorrectionsStatus==commonfn.getStatusCode('Created') || props.item.attendanceCorrectionsStatus==commonfn.getStatusCode('For Review')" class='warning--text'>{{ props.item.attendanceCorrectionsChargeableHours }}</b>
                                        <b v-if="props.item.attendanceCorrectionsStatus==commonfn.getStatusCode('Approved')" class='green--text'>{{ props.item.attendanceCorrectionsChargeableHours }}</b>
                                        <b v-if="props.item.attendanceCorrectionsStatus==commonfn.getStatusCode('Rejected')" class='red--text'>{{ props.item.attendanceCorrectionsChargeableHours }}</b>
                                    </td>
                                    <td>
                                        <b v-if="props.item.timeOffWithUnApproved==1" class='warning--text' >{{ props.item.timeOffChargeableHours }}</b>
                                        <b v-else class='green--text'>{{ props.item.timeOffChargeableHours }}</b>
                                    </td>
                                    <td>
                                        <span v-if="exceedsDailyHours(props.item.otChargeableHours)">
                                            <b class='red--text'>{{ props.item.otChargeableHours }}</b> 
                                        </span>
                                        <span v-else>
                                            <b v-if="props.item.otWithUnApproved==1" class='warning--text' >{{ props.item.otChargeableHours }}</b>
                                            <b v-else class='green--text'>{{ props.item.otChargeableHours }}</b>    
                                        </span>
                                    </td>
                                </tr>
                            </template>
                            <template v-slot:footer>

                                <!-- mobile view -->
                                <tr v-if="isMobile">
                                    <td :colspan="headers_timesheet.length" class="pa-1">
                                        <v-card class="elevation-1" @click="viewDetails(props.item)">
                                            <v-toolbar flat height="42">
                                                <b>Totals</b>
                                                <v-spacer></v-spacer>
                                            </v-toolbar>
                                            <v-layout row wrap align-center class="section-layout">
                                                <v-flex xs12 class="text-xs-left mt-1 mb-1">
                                                    <v-layout row>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text">Total Hours</div>
                                                            <div>{{ timesheetTotals.totalHours }}</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text">Chargeable Hours</div>
                                                            <div>{{ timesheetTotals.chargeablePayrollHours }}</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text">Night Diff Hours</div>
                                                            <div>{{ timesheetTotals.chargeableNDHours }}</div>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text">Workshift ND Hours</div>
                                                            <div>{{ timesheetTotals.chargeableWSNDHours }}</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text">Attendance Corrections</div>
                                                            <div>{{ timesheetTotals.attendanceCorrectionsChargeableHours }}</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text">Time Off Hours</div>
                                                            <div>{{ timesheetTotals.timeOffChargeableHours }}</div>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text">Overtime Hours</div>
                                                            <div>{{ timesheetTotals.otChargeableHours }}</div>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>
                                        </v-card>
                                    </td>
                                </tr>

                                <!-- desktop view -->
                                <tr v-else class="font-weight-bold">
                                    <td colspan="4">Total</td>
                                    <td>{{ timesheetTotals.totalHours }}</td>
                                    <td>{{ timesheetTotals.chargeablePayrollHours }}</td>
                                    <td>{{ timesheetTotals.chargeableNDHours }}</td>
                                    <td>{{ timesheetTotals.chargeableWSNDHours }}</td>
                                    <td>{{ timesheetTotals.attendanceCorrectionsChargeableHours }}</td>
                                    <td>{{ timesheetTotals.timeOffChargeableHours }}</td>
                                    <td>{{ timesheetTotals.otChargeableHours }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                          
                    </v-card>
                </v-flex>
            </v-layout>

            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="pageQueryId"></update-history>
                </v-flex>
            </v-layout>

            <v-snackbar v-model="snackbar" :bottom="y === 'top'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
                :right="x === 'right'" :timeout="6000" :top="y === 'top'" :vertical="mode === 'vertical'"
                >{{snackbarText}}
                <v-btn color="primary" flat @click="snackbar = false">Close</v-btn>
            </v-snackbar>
        </v-flex>

        <v-dialog v-model="dialogAllEmployees" width="650">   
            <view-all-employees ref="allEmployeesRef" @send="viewAllHandler" :dialogAllEmployees.sync="dialogAllEmployees"></view-all-employees>
        </v-dialog>
        <v-dialog v-model="dialogOkCancel" persistent width="600">
            <ok-cancel :msg="dialogOkCancelMsg" :dialogOkCancel.sync="dialogOkCancel" @ok="deleteTimesheet"></ok-cancel>
        </v-dialog>
        <v-dialog v-model="dialogTeamSelector" width="700">
            <team-selector :teams="matchingTeams" :dialogTeamSelector.sync="dialogTeamSelector"></team-selector>
        </v-dialog>

        <!-- status messaging component -->
        <status-messaging :page_query_id="pageQueryId" @refresh="updateHandler"></status-messaging>
    </v-layout>  
</template>
<script>

import { syncTeamContext } from '@/helpers/team-selector'
import timesheetApi from '@/api/timesheet'
import commonfn from '@/common/functions'   //for refactor
import AppPageID from '@/constants/app_page_ids'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import numFormat from '@/common/num_format'
import awsS3Helper from '@/helpers/aws-s3'
import rowsPerPageItems from '@/constants/rows-per-page'
import { hasEditRights } from '@/helpers/access-permissions'
import { getRowsPerPage, updateRowsPerPage } from '@/helpers/user-prefs'
import { hasTeamEditRights, hasTeamDeleteRights, hasTeamApproverRights, hasTeamSelfApproverRights } from '@/helpers/myteams-permissions'

export default {    
    name: 'MyTimesheet',
    metaInfo: {
        title: 'My Timesheet',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'My Timesheet' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ]
    }, 
    components: {
        'view-all-employees': () => import('@/components/Timesheet/EmployeesByCutOff'),
        'help-link': () => import('@/components/Common/HelpLink'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory'),
        'ok-cancel': ()=> import("@/components/BasicPopups/OkCancel"),
        'team-selector': () => import('@/components/Team/TeamSelector')
    },   
    data () {
        return {
            commonfn,
            numFormat,
            awsS3Helper,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: getRowsPerPage(this.$route.name),
            },
            mode: null,
            x: null,
            y: null,
            error: false,
            errorMessage: '',
            loading: false,
            loading_download: false,
            loading_btn: false,
            expand: false,
            dialogOkCancelMsg: '',
            dialogOkCancel: false,
            timesheetData: [],
            headers_timesheet: [
                {text: 'Date',align: 'left',value: 'date', width:'10%',sortable:false},
                {text: 'Workshift',align: 'left',value: 'date', width:'5%',sortable:false},
                {text: 'Clock In/Out',align: 'left',value: 'clockIn', width:'10%',sortable:false},
                {text: 'Late',align: 'left',value: 'minsLate', width:'5%',sortable:false},
                {text: 'Total Hours',align: 'left',value: 'totalHours', width:'5%',sortable:false},
                {text: 'Chargeable',align: 'left',value: '', width:'5%',sortable:false},   
                {text: 'Night Diff',align: 'left',value: '', width:'5%',sortable:false},  
                {text: 'WS ND',align: 'left',value: '', width:'5%',sortable:false},                 
                {text: 'Corrections',align: 'left',value: '', width:'5%',sortable:false},
                {text: 'Time Off',align: 'left',value: '', width:'5%',sortable:false},
                {text: 'Overtime',align: 'left',value: '', width:'5%',sortable:false},
            ],
            timesheetTotals: null,
            menu_status: false,
            timereport: null,
            snackbar: false,
            snackbarText: '',
            selectedUserId: null,
            dialogAllEmployees: false,
            dialogTeamSelector: false,
            matchingTeams: []
        }
    },
    methods: {  
        showDeleteDialog() {
            this.dialogOkCancelMsg = `This will change the status of the timesheet to <b>Unsubmitted</b>. <br><br><b>Do you want to proceed?</b>`
            this.dialogOkCancel = true
        },
        async deleteTimesheet() {
            try {
                this.loading_btn = true
                const response = await timesheetApi.deleteTimeReport(this.timereport.timeReportId, this.userPageKey)
                if (response.status == 200) {
                    await this.getTimesheet(false)
                }
                this.loading_btn = false
                this.dialogOkCancel = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        showOtherEmployees() {
            //refresh every access to get latest status
            this.$refs.allEmployeesRef.getTeamTimeReports(this.selectedCutoffId, this.accessedFromCompanyPages)
            this.dialogAllEmployees = true
        },
        viewAllHandler(userId) {
            this.selectedUserId = userId
            this.getTimesheet(false)
        },
        exceedsDailyHours(otChargeableHours) {
            if (!otChargeableHours) return false
            let [h, m] = otChargeableHours.split(":").map(Number)
            return (h + m / 60) > 8
        },
        viewAttendanceCorrections(){
            if (this.viewedByOwner) {
                this.$router.push(`/myattendance/corrections/${this.selectedCutoffId}`)
            }else{
                if (this.$router.currentRoute.path.includes('myteam/timesheet')) {
                    this.$router.push(`/myteam/corrections/${this.selectedCutoffId}`)
                }else{
                    this.$router.push(`/company/corrections/${this.selectedCutoffId}`)
                }
            }
        },
        viewTimeOff() {
            if (this.viewedByOwner) {
                this.$router.push(`/myattendance/timeoff/${this.selectedCutoffId}`)
            }else{
                if (this.$router.currentRoute.path.includes('myteam/timesheet')) {
                    this.$router.push(`/myteam/timeoff/${this.selectedCutoffId}`)
                }else{
                    this.$router.push(`/company/timeoff/${this.selectedCutoffId}`)
                }
            }
        },
        viewOvertime() {
            if (this.viewedByOwner) {
                this.$router.push(`/myattendance/overtime/${this.selectedCutoffId}`)
            }else{
                if (this.$router.currentRoute.path.includes('myteam/timesheet')) {
                    this.$router.push(`/myteam/overtime/${this.selectedCutoffId}`)
                }else{
                    this.$router.push(`/company/overtime/${this.selectedCutoffId}`)
                }
            }
        },
        viewTaskCharges() {
            if (this.viewedByOwner) {
                this.$router.push(`/projects/charges`)
            }else{
                if (this.$router.currentRoute.path.includes('myteam/timesheet')) {
                    this.$router.push(`/projects/myteam/charges`)
                }else{
                    //TODO - project charges approvers view - company level
                    //projects/company/charges
                }
            }
        },
        viewUserProfile(data, loggedInUserId) {
            if (data.userId == loggedInUserId)
                this.$router.push(`/myprofile`)
            else 
                this.$router.push(`/hr/employees/${data.userId}`)
        },
        async rejectTimeReport() {
            try {
                this.loading_btn = true
                const response = await timesheetApi.rejectTimeReport(this.timereport.timeReportId, this.userPageKey)
                if (response && response.status == 200) {
                    await this.getTimesheet(false)
                }
                this.loading_btn = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async approveTimeReport() {
            try {
                this.loading_btn = true
                const response = await timesheetApi.approveTimeReport(this.timereport.timeReportId, this.userPageKey)
                if (response && response.status == 200) {
                    await this.getTimesheet(false)
                }
                this.loading_btn = false
            }catch(error) {
                this.error = true
                this.errorMessage = error
            }
        },
        async submitTimeReport() {
            try{
                this.loading_btn = true
                var data = {
                    userId: this.selectedUserId,
                    timeReportId : this.timereport.timeReportId,
                    cutoffId : this.timereport.cutoffId
                }
                const response = await timesheetApi.upsertTimeReport(data)
                if (response && response.status == 200) {
                    await this.getTimesheet(false)
                }
                this.loading_btn = false

            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async downloadToExcel() {
            try {
                this.loading_download = true
                const response = await timesheetApi.getExcelReport(this.selectedCutoffId, this.selectedUserId, this.userPageKey)
                const userName = `${this.timereport.firstName} ${this.timereport.lastName}`
                var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' })
                var link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = `TIMESHEET-${userName}-${this.header_text}.xlsx`
                link.click()
                this.loading_download = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        viewDetails(data) {
            if (this.viewedByOwner) {
                 var transDate = this.$moment(data.transDate).format('YYYY-MM-DD')
                this.$router.push('/myattendance/daily/'+transDate)
            }
        }, 
        async getTimesheet(show_loading) {
            try {
                this.loading = show_loading
                var response = null

                if (this.viewedByOwner) {
                    //accessed by timesheet owner
                    response = await timesheetApi.getByCutoffByUser(this.selectedCutoffId)
                } else {
                    //accessed by approver
                    response = await timesheetApi.getByCutoffBySelectedUser(this.selectedCutoffId, this.selectedUserId, this.userPageKey)
                }

                if (response && response.status == 200) {
                    this.timereport = response.data.timeReport 
                    this.timesheetData = response.data.items
                    this.timesheetTotals = response.data.totals
                }

                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async updateHandler(data) {
            this.loading_btn = true
            await this.getTimesheet(false)
            this.loading_btn = false
            
            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        },
        async initialize() {
            this.selectedUserId = this.$route.params.userId

            await this.getTimesheet(true)

            const result = await syncTeamContext(this.timereport.userId)
            if (result && result.action === 'SHOW_DIALOG') {
                this.matchingTeams = result.teams
                this.dialogTeamSelector = true
            }
        }
    },
    async created() {
        this.initialize()

        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: null,
            headerPageTitle: 'Timesheet Details'
        })
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            updateRowsPerPage(this.$route.name, newVal)
        }
    },
    computed: {
        pageQueryId() {
            return `timesheet${this.selectedCutoffId}${this.selectedUserId}`
        },
        hasEditRights() {
            return hasEditRights(this.$router.currentRoute.path) ||
                    hasTeamEditRights(AppPageID.TeamTimesheet)
        },
        hasTeamDeleteRights() {
            return hasTeamDeleteRights(AppPageID.TeamTimesheet)
        },
        hasTeamSelfApproverRights() {
            return hasTeamSelfApproverRights(AppPageID.TeamTimesheet)
        },
        hasTeamApproverRights() {
            return hasTeamApproverRights(AppPageID.TeamTimesheet)
        },
        statusLabel() {
            if (!this.timereport) return ''
            return this.unsubmitted ? 'Unsubmitted' : this.commonfn.getStatusDescription(this.timereport.status)
        },
        menuItems() {
            // Guard clause
            if (!this.timereport) return []

            const items = []

            // Map your existing flags/rights to the structure
            const canSubmit = this.canSubmitConditions
            const canApprove = this.canApproveConditions
            const canReject = this.canRejectConditions
            const canDelete = this.canDeleteConditions // Refers to the "Unsubmitted" action

            if (canSubmit) {
                items.push({ label: 'Submit For Review', action: this.submitTimeReport })
            }

            if (canApprove) {
                items.push({ label: 'Approve', action: this.approveTimeReport })
            }

            if (canReject) {
                items.push({ label: 'Reject', action: this.rejectTimeReport })
            }

            if (canDelete) {
                // Label matches the original UI text "Unsubmitted"
                items.push({ label: 'Unsubmitted', action: this.showDeleteDialog })
            }

            return items
        },
        isStatusMenuDisabled() {
            return this.isNoPermission || this.isOwnerDisabled || this.isApproverDisabled || !this.menuItems.length
        },
        isNoPermission() {
            return !this.hasEditRights && !this.hasTeamApproverRights
        },
        isOwnerDisabled() {
            if (!this.viewedByOwner) return false

            return this.isPeriodLocked ||
                this.hasUnApprovedItems
        },
        isApproverDisabled() {
            if (this.viewedByOwner) return false
            return this.isPeriodLocked
        },
        isPeriodLocked() {
            return this.frozenPeriod || this.closedPeriod
        },
        isForReview() {
            return this.timereport && this.timereport.status === commonfn.getStatusCode('For Review')
        },
        isApproved() {
            return this.timereport && this.timereport.status === commonfn.getStatusCode('Approved')
        },
        accessedFromCompanyPages(){
            return this.$router.currentRoute.path.includes('company/timesheets')
        },
        accessedFromMyTeamPages(){
            return this.$router.currentRoute.path.includes('myteam')
        },
        userPageKey() {
            if (this.$router.currentRoute.path.includes('company/timesheets')) {
                return pageKeys.timesheet_company_approver
            }else if (this.$router.currentRoute.path.includes('myteam/timesheet')) {
                return pageKeys.timesheet_team_approver
            }else{
                return pageKeys.timesheet
            }
        },
        pageLink() {
            if (this.timereport) {
                if (this.viewedByOwner) {
                    if (this.$router.currentRoute.path.includes('company/timesheets')) {
                        return `company${this.$router.currentRoute.path.replace('/myattendance','')}`
                    }else{
                        return `myteam${this.$router.currentRoute.path.replace('/myattendance','')}`
                    }
                }else{
                    return `myattendance${this.$router.currentRoute.path.replace('/myteam','').replace('/company','')}`
                }
            }
        },
        commentsData() {
            if (!this.timereport!=null)
                return {
                    pageQueryId: this.pageQueryId,
                    pageItemCreatedBy: this.timereport.userId,
                    pageLink: this.pageLink,
                    pageKey: pageKeys.timesheet_team_approver,
                    notificationTypeId: notificationTypes.timesheet
                }
        },
        selectedCutoffId() {
            return this.$route.params.cutOffId
        },
        viewedByOwner() {
            return this.$router.currentRoute.path.includes('myattendance/timesheet')
                    || this.$store.state.userId == this.selectedUserId
        },
        otExceedsDailyHour() {
            return this.timesheetData.filter(x => {
                if (!x.otChargeableHours) return false;
                let [h, m] = x.otChargeableHours.split(":").map(Number);
                return (h + m / 60) > 8
            }).length;
        },
        incomplete_clock_hours() {
            return this.timesheetData.filter(item => {
                return item.completeClockHours == 'NO'
            }).length
        },
        unapproved_attcorrections() {
            return this.timesheetData.filter(item => {
                return (
                        item.attendanceCorrectionsStatus == commonfn.getStatusCode('Created') ||
                        item.attendanceCorrectionsStatus == commonfn.getStatusCode('Rejected') ||
                        item.attendanceCorrectionsStatus == commonfn.getStatusCode('For Review')
                    )
            }).length
        },
        unapproved_timeoff() {
            return this.timesheetData.filter(item => {
                return item.timeOffWithUnApproved == 1
            }).length
        },
        unapproved_overtime() {
            return this.timesheetData.filter(item => {
                return item.otWithUnApproved == 1
            }).length
        },
        hasUnApprovedItems() {
            return this.unapproved_attcorrections>0||
                    this.unapproved_timeoff>0||
                    this.unapproved_overtime>0
        },
        unsubmitted() {
            return commonfn.getStatusDescription(this.timereport.status)=='Not Available'
        },
        header_text() {
            if (this.timereport)
                return this.$moment(this.timereport.cutoffStart).format("MMM DD, YYYY") + " - " + this.$moment(this.timereport.cutOffEnd).format("MMM DD, YYYY") 
            return ''
        },
        header_text_mobile() {
            if (this.timereport)
                return this.$moment(this.timereport.cutoffStart).format("MMM DD") + " - " + this.$moment(this.timereport.cutOffEnd).format("DD, YYYY") 
            return ''
        },
        frozenPeriod(){
            if (this.timereport)
                return this.timereport.cutOffStatus==commonfn.getStatusCode('Frozen')
        },
        closedPeriod(){
            if (this.timereport)
                return this.timereport.cutOffStatus==commonfn.getStatusCode('Closed')
        },
        disableIfOwner() {
            return this.frozenPeriod ||
                    this.closedPeriod ||
                    this.hasUnApprovedItems || 
                    (
                        !this.accessedFromMyTeamPages && 
                        this.timereport.status==commonfn.getStatusCode('For Review')
                    ) ||
                    (
                        !this.accessedFromMyTeamPages &&
                        this.timereport.status==commonfn.getStatusCode('Approved')
                    )
        },
        disableIfApprover() {
            return this.frozenPeriod||this.closedPeriod
        },
        canSubmitConditions() {
            return this.hasEditRights && 
                !this.hasUnApprovedItems &&
                (
                    this.timereport.status==commonfn.getStatusCode('Not Available')||
                    this.timereport.status==commonfn.getStatusCode('Rejected')
                ) 
        },
        canApproveConditions() {
            return this.viewedByOwner ?
                this.hasTeamSelfApproverRights && (
                    this.timereport.status==commonfn.getStatusCode('For Review')||
                    this.timereport.status==commonfn.getStatusCode('Rejected')
                ) :
                this.hasTeamApproverRights && (
                    this.timereport.status==commonfn.getStatusCode('For Review')||
                    this.timereport.status==commonfn.getStatusCode('Rejected')
                )
        },
        canRejectConditions() {
            return this.viewedByOwner ?
                this.hasTeamSelfApproverRights && ( 
                    this.timereport.status==commonfn.getStatusCode('For Review')||
                    this.timereport.status==commonfn.getStatusCode('Approved')
                ) :
                this.hasTeamApproverRights && ( 
                    this.timereport.status==commonfn.getStatusCode('For Review')||
                    this.timereport.status==commonfn.getStatusCode('Approved')
                )
        },
        canDeleteConditions() {
            return this.hasTeamDeleteRights && 
                    this.timereport.status==commonfn.getStatusCode('Rejected')
        }
    }
}
</script>
<style scoped>
.section-layout {
    padding:0px 23px 0px 23px;
}
</style>